goog.provide('el8.appchart.actions.medOrder');

goog.require('el8.uiwidget.deleteConfirm');
goog.require('el8.appchart.dialog.ordermed.discontinue');
goog.require('el8.appchart.dialog.ordermed.documentDiscontinue');
goog.require('el8.appchart.dialog.ordermed.txStartDate');
goog.require('el8.appchart.medsMgr');
goog.require('el8.appchart.permissions');
goog.require('el8.util.amplitude.prescriptionFormHelpers');
goog.require('el8.ptdata.medOrders');


el8.appchart.actions.medOrder = function(opts) {

    opts = opts || {};
    var item = opts.item;  // medOrder
    var menu = [];

    if (item.isRxDownload()) {
        menu.push({
            actionText: 'Remove',
            actionFn: function() {
                var confirmStr = "downloaded order (which has fills awaiting acknowledgement) AND its fills";  // Surescripts order
                el8.uiwidget.deleteConfirm(confirmStr,
                    function() {
                        el8.ptdata.medOrders.deleteItem(item);
                    }
                );
            }
        });

        // No need to do any of the below
        return menu;
    }

    if (!opts.chartFeed) {
        // these actions have moved to floating links in the chart feed
        if (item.isThreadActive()) {
            menu.push({
                actionText: 'Rx: Refill',
                actionFn: function() {
                    if (opts.amplitudeSource) {
                        el8.util.amplitude.logStartPrescription(
                            opts.amplitudeSource,
                            el8.appchart.mgr.orderForm.getPrintFormType(item)
                        );
                    }
                    el8.appchart.mgr.orderForm.refillMedOrder(item);
                }
            });
            menu.push({
                actionText: 'Rx: Change Dose',
                actionFn: function() {
                    if (opts.amplitudeSource) {
                        el8.util.amplitude.logStartPrescription(
                            opts.amplitudeSource,
                            el8.appchart.mgr.orderForm.getPrintFormType(item)
                        );
                    }
                    el8.appchart.mgr.orderForm.changeMedOrder(item);
                }
            });
            if (el8.appchart.permissions.allow('prescribeMeds')) {
                menu.push({
                    actionText: 'Rx: Discontinue',
                    actionFn: function() {
                        el8.appchart.dialog.ordermed.discontinue.show({order: item});
                    }
                });
                if (el8Globals.FEATURES.NewSurescripts && item.isERx() &&
                        !(item.isCanceled()||item.isCancelPending())
                    ) {
                    menu.push({
                        actionText: 'Cancel this eRx order',
                        actionFn: function() {
                            el8.util.amplitude.logStartCancelRxRequest(opts.amplitudeSource, item.isControlled());
                            el8React.openCancelPrescriptionDialog(item.getId());
                        }
                    });
                }
            }
        } else {
            menu.push({
                actionText: 'Rx: Re-Order',
                actionFn: function() {
                    if (opts.amplitudeSource) {
                        el8.util.amplitude.logStartPrescription(
                            opts.amplitudeSource,
                            el8.appchart.mgr.orderForm.getPrintFormType(item)
                        );
                    }
                    el8.appchart.mgr.orderForm.reOrderMedOrder(item);
                }
            });
        }
        menu.push({
            actionText: 'Document Change',
            actionFn: function() {
                var prescribingPhysicianId = item.getPrescribingPhysicianId();
                var prescriberId;
                if (prescribingPhysicianId) {
                  prescriberId = prescribingPhysicianId;
                } else {
                  prescriberId = el8.data.currUser.isPhysician() ? el8.data.currUser.getStaffId() : null;
                }
                el8.appchart.dialog.ordermed.document.show({
                    order: item,
                    type: 'DoseChange',
                    prescriberId: prescriberId
                });
            }
        });
    } else {
        // except d/c-ing, which is not a floating link in the chart feed
        if (item.isThreadActive() && el8.appchart.permissions.allow('prescribeMeds')) {
            menu.push({
                actionText: 'Rx: Discontinue',
                actionFn: function() {
                    el8.appchart.dialog.ordermed.discontinue.show({order: item});
                }
            });
        }
    }
    if (item.isThreadActive()) {
        menu.push({
            actionText: 'Document Discontinue',
            actionFn: function() {
                el8.appchart.dialog.ordermed.documentDiscontinue.show({
                    order: item
                });
            }
        });
    }
    if (!item.isDocumentMed()) {
        menu.push({
            actionText: 'View Order',
            actionFn: function() {
                el8.appchart.showItemDetail(item);
                return false;
            }
        });
    }
    menu.push({
        actionText: 'Export to Note (HPI)',
        actionFn: function() {
            el8.appchart.mgr.notes.addReference({item: item, sectionName: 'problem'});
        }
    });
    menu.push({
        actionText: 'Export to Note (Meds)',
        actionFn: function() {
            el8.appchart.mgr.notes.addReference({item: item});
        }
    });
    menu.push({
        actionText: 'Move to Other Med (un-merge)',
        actionFn: function() {
            el8.appchart.medsHx.main.show({
                medOrderId: item.getId(),
                doMoveMerge: true
            });
        }
    });
    if (item.isThreadActive()) {
        menu.push({
            actionText: 'Set as ' +
                (item.isThreadPermanent() ? 'Temporary' : 'Permanent') + ' Med',
            actionFn: function() {
                el8.appchart.medsMgr.toggleThreadPermanence(item.getThreadId());
            }
        });
    }
    if (!item.isDocumentMed() && item.isThreadActive()) {
        menu.push({
            actionText: item.getFulfillmentMgr().hasPaperFulfillment() ? 'Re-print Script' : 'Print Script',
            actionFn: function() {
                el8.ptdata.medOrders.printSingle(item);
                return false;
            }
        });
    }
    if (item.getFulfillmentMgr().isLatestERxSuccess()) {
        menu.push({
            actionText: 'Print Patient Copy',
            actionFn: function() {
                el8.ptdata.medOrders.printCopy([item]);
                return false;
            }
        });
    }
    if (!opts.chartFeed) {
        menu.push({
            actionText: 'Write Message',
            actionFn: function() {
                el8.appshared.message.prePopulateNewMessage({
                    toDocId: item.getId()
                });
            }
        });
    }
    if (!el8Globals.FEATURES.MDToolboxEPCS || !item.getMedication().isControlled()) {
        menu.push({
            actionText: 'Remove',
            actionFn: function() {
                 var confirmStr = el8.ptdata.medOrderFills.orderHasUnsignedFills(item.getId()) ?
                    "medication order (which has fills awaiting acknowledgement) AND its fills from the patient chart" :
                    "medication order";
                 el8.uiwidget.deleteConfirm(confirmStr,
                     function() {
                         el8.ptdata.medOrders.deleteItem(item);
                     }
                 );
            }
         });
    }

    return menu;

};
